<template>
    <v-main>
      <v-layout row wrap>
        <v-flex xs12 sm12 class="mx-1">
                  <v-list v-if="loadPacotes">
                    <v-list-item-group>
                        <v-skeleton-loader v-for="(i) in 5" :key="i" max-width="1200px" type="card-heading, list-item, divider"> </v-skeleton-loader>
                    </v-list-item-group>
                  </v-list>

                  <v-list v-if="!loadPacotes">
                    <v-list-item v-for="(item, i) in pacotesExamesFiltrados" :key="i">
                      <v-list-item-content>
                          <v-card height="150px" outlined>
                            <v-card-title>
                              {{ item.nome }}
                            </v-card-title>
                            <v-list-item-subtitle v-for="(it,j) in item.exames" :key="j">
                              <div v-if="j <= 1" class="ml-1">
                                - {{ it.apelido}}
                              </div>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="ml-2" v-if="item.exames.length > 2">
                              mais {{ item.exames.length -2 }} exames
                          </v-list-item-subtitle>
                          </v-card>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="green"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click=" exibirVincularMedicos(item)"
                              >
                              <v-icon>mdi-doctor</v-icon>

                              </v-btn>
                            </template>
                            <span>Vincular médico</span>
                          </v-tooltip>

                          </v-list-item-action>
                          <v-list-item-action>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="orange"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click=" exibirEditarPacote(item)"
                                  >
                                  <v-icon>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>Editar pacote</span>
                            </v-tooltip>
                          </v-list-item-action>
                          <v-list-item-action>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="red"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click="isRemovePacote = true, pacoteSelecionado = item"
                                >
                                 <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                              <span> Remover pacote</span>
                            </v-tooltip>
                          </v-list-item-action>
                    </v-list-item>
                  </v-list>

                    <v-card-actions>
                    <v-spacer/>
                    <v-btn color="green"
                      fab
                      dark
                      fixed
                      bottom
                      right
                      @click="isAddPacote = true"
                    >
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                  </v-card-actions>

                  <v-snackbar
                    v-model="cadastroSucesso"
                    color="success"
                  >
                    Pacote criado com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="cadastroSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="removerSucesso"
                    color="success"
                  >
                    Pacote removido com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="removerSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="editarSucesso"
                    color="success"
                  >
                    Pacote editado com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="editarSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="vincularSucesso"
                    color="success"
                  >
                    Médicos vinculados com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="vincularSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>
              <!--PACOTE DE EXAMES LABORATORIAIS SADT-->
         
                <!-- <v-card outlined class="ma-5" style="overflow-y: auto; height: 550px;">
                  <v-card-title>
                    <v-spacer/>
                    <v-text-field prepend-icon="search" placeholder="Buscar Pacote" v-model="filtroBusca"></v-text-field>
                  </v-card-title>
                  <v-list v-if="loadPacotes">
                    <v-list-item-group>
                        <v-skeleton-loader v-for="(i) in 5" :key="i" max-width="1200px" type="card-heading, list-item, divider"> </v-skeleton-loader>
                    </v-list-item-group>
                  </v-list>

                  <v-list v-if="!loadPacotes">
                    <v-list-item v-for="(item, i) in pacotesExamesFiltrados" :key="i">
                      <v-list-item-content>
                          <v-card height="150px" outlined>
                            <v-card-title>
                              {{ item.nome }}
                            </v-card-title>
                            <v-list-item-subtitle v-for="(it,j) in item.exames" :key="j">
                              <div v-if="j <= 1" class="ml-1">
                                - {{ it.apelido}}
                              </div>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="ml-2" v-if="item.exames.length > 2">
                              mais {{ item.exames.length -2 }} exames
                          </v-list-item-subtitle>
                          </v-card>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="green"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click=" exibirVincularMedicos(item)"
                              >
                              <v-icon>mdi-doctor</v-icon>

                              </v-btn>
                            </template>
                            <span>Vincular médico</span>
                          </v-tooltip>

                          </v-list-item-action>
                          <v-list-item-action>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="orange"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click=" exibirEditarPacote(item)"
                                  >
                                  <v-icon>edit</v-icon>
                                </v-btn>
                              </template>
                              <span>Editar pacote</span>
                            </v-tooltip>
                          </v-list-item-action>
                          <v-list-item-action>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="red"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  @click="isRemovePacote = true, pacoteSelecionado = item"
                                >
                                 <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                              <span> Remover pacote</span>
                            </v-tooltip>
                          </v-list-item-action>
                    </v-list-item>
                  </v-list>

                    <v-card-actions>
                    <v-spacer/>
                    <v-btn color="green"
                      fab
                      dark
                      fixed
                      bottom
                      right
                      @click="isAddPacote = true"
                    >
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                  </v-card-actions>

                  <v-snackbar
                    v-model="cadastroSucesso"
                    color="success"
                  >
                    Pacote criado com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="cadastroSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="removerSucesso"
                    color="success"
                  >
                    Pacote removido com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="removerSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="editarSucesso"
                    color="success"
                  >
                    Pacote editado com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="editarSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>

                  <v-snackbar
                    v-model="vincularSucesso"
                    color="success"
                  >
                    Médicos vinculados com sucesso!

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="vincularSucesso = false"
                      >
                        Fechar
                      </v-btn>
                    </template>
                  </v-snackbar>
                </v-card> -->
        </v-flex>

        <!--DIALOG CADASTRAR PACOTE DE EXAMES-->
        <v-dialog persistent v-model="isAddPacote" width="800" height="600">
          <v-card height="600">
            <v-card-title>
              Cadastrar pacote de exames
            </v-card-title>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
            <v-text-field :rules="nameRules" v-model="nomePacote" label="Nome do pacote" class="mx-5"></v-text-field>
            <v-autocomplete :rules="examesRules" class="ma-4" solo @change="searchExame = ''" v-model="exameSelecionado" :items="exames" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
          </v-form>
            <!-- <v-card-text>
               <v-autocomplete class="mt-0 mt-0" solo @change="searchExame = ''" v-model="exameSelecionado" :items="exames" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
            </v-card-text> -->
            <v-card-actions>
              <v-spacer/>
              <v-btn right color="primary" v-show="listaExames.length > 0" @click="listaExames = []" outlined> Limpar <v-icon color="primary"> mdi-broom</v-icon> </v-btn>
            </v-card-actions>
            <v-card falt elevation="0" height="250px" style="overflow-y: auto;">
            <v-list>
              <v-list-item v-for="(item, i) in listaExames" :key="i">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.apelido }}
                </v-list-item-title>
                <v-divider />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn right icon color="red" @click="listaExames.splice(item, 1)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            </v-card>
            <v-card-actions class="d-flex justify-end align-end">
              <v-spacer/>
              <v-btn class="white--text" color="orange" @click="isAddPacote = false, listaExames = []">
                Voltar
              </v-btn>
              <v-btn :loading="loadCadastro" color="primary" @click="cadastrarPacoteExame()">
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!--DIALOG EDITAR PACOTE DE EXAMES-->
        <v-dialog persistent v-model="isEditarPacote" width="800" height="600">
          <v-card >
            <v-card-title>
              {{pacoteSelecionado.nome}}
            </v-card-title>
            <v-form
              ref="form1"
              v-model="valid1"
              lazy-validation
            >
            <v-text-field :rules="nameRules" v-model="pacoteSelecionado.nome" label="Nome do pacote" class="mx-5"></v-text-field>
            <v-autocomplete :rules="examesRules" class="ma-4" solo @change="searchExame = ''" v-model="exameSelecionado" :items="exames" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
            </v-form>
            <v-card-actions>
              <v-spacer/>
              <v-btn right color="primary" v-show="listaExames.length > 0" @click="listaExames = []" outlined> Limpar <v-icon color="primary"> mdi-broom</v-icon> </v-btn>
            </v-card-actions>
            <v-card falt elevation="0" height="250px" style="overflow-y: auto;">
            <v-list>
              <v-list-item v-for="(item, i) in listaExames" :key="i">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.apelido }}
                </v-list-item-title>
                <v-divider />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn right icon color="red" @click="listaExames.splice(item, 1)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            </v-card>
            <v-card-actions>
              <v-spacer/>
              <v-btn class="white--text" color="orange" @click="isEditarPacote = false, listaExames = false">Voltar</v-btn>
              <v-btn color="primary" @click="editarPacoteExame()">Confirmar alterações</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        <!--DIALOG VINCULAR PACOTES AO MÉDICO-->
        <v-dialog persistent v-model="isVincularMedicos" width="800" height="600">
          <v-card>
            <v-card-title>
              {{pacoteSelecionado.nome}}
            </v-card-title>

            <v-card flat width="600" height="400" style="overflow-y: auto;">
              <v-select
                class="mx-5"
                prepend-icon="person"
                v-model="medicosSelecionados"
                :items="listaFuncionariosAtivos"
                label="Selecionar médicos"
                multiple
                item-text="nomeTratamento"
                item-value="_id"
                chips
                deletable-chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggle"
                  >
                    <v-list-item-action>
                      <v-icon :color="medicosSelecionados.length > 0 ? 'indigo darken-4' : ''">
                        {{ icon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todos
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-card>
            <v-card-actions>
              <v-spacer/>
              <v-btn class="white--text" color="orange" @click="isVincularMedicos = false, medicosSelecionados = []">Voltar</v-btn>
              <v-btn color="primary" @click="vincularPacote()">Confirmar alterações</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

         <!--DIALOG REMOVER PACOTE DE EXAMES-->
        <v-dialog v-model="isRemovePacote" height="200" width="300">
          <v-card >
            <v-card-title>
              Tem certeza?
            </v-card-title>
            <v-card-text>
              Ao remover este pacote de exames, não será possível desfazer as alterações.
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn text class="white--text" color="red" @click="isRemovePacote = false">Cancelar</v-btn>
              <v-btn text color="primary" @click="removerPacoteExame(pacoteSelecionado), isRemovePacote = false">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-main>
    </template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import medicoService from '../../../services/medico.service'
import usuarioService from '../../../services/usuario.service'
export default {
  name: 'listaAdministrador',
  components: {
    // HelloWorld
  },
  props: {
    sadt: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      page: 1,
      tipo: 4,
      searchAtivo: '',
      searchDesativo: '',
      isEditing: true,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      administradorSelecionado: null,
      headers: [{
        text: 'Nome do Médico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false
      }
      ],
      headersDesativado: [{
        text: 'Nome do Médico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ativar médico',
        align: 'center',
        value: 'name',
        sortable: false
      }
      ],
      listaFuncionarios: [],
      user: null,
      items: [{
        username: 'Elvis',
        idMedico: 1
      },
      {
        username: 'Cassio',
        idMedico: 3
      },
      {
        username: 'Leandro',
        idMedico: 2
      },
      {
        username: 'Ana',
        idMedico: 15
      },
      {
        username: 'Ricardo',
        idMedico: 14
      },
      {
        username: 'Cleison',
        idMedico: 22
      }
      ],
      pacotesExames: [],
      tab: '',
      isAddPacote: false,
      searchExame: '',
      exameSelecionado: '',
      isLoading: false,
      count: 0,
      entries: [],
      listaExames: [],
      nomePacote: '',
      filtroBusca: '',
      loadCadastro: false,
      cadastroSucesso: false,
      removerSucesso: false,
      editarSucesso: false,
      vincularSucesso: false,
      loadPacotes: false,
      isRemovePacote: false,
      isEditarPacote: false,
      isVincularMedicos: false,
      valid: true,
      valid1: true,
      nameRules: [
        v => !!v || 'O nome é obrigatório'
      ],
      examesRules: [
        v => (Array.isArray(this.listaExames) && this.listaExames.length > 0) || 'Selecione pelo menos um exame'
      ],
      pacoteSelecionado: '',
      medicosSelecionados: [],
      nomePacoteEdit: ''
    }
  },
  mounted () {
    console.log('em mounted lista medicos...')
    this.user = this.$store.getters.usuario
    this.listarPacoteExames()
    // console.log(this.user);
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.allSeleced) {
          this.medicosSelecionados = []
        } else {
          this.medicosSelecionados = this.listaFuncionariosAtivos.slice()
        }
      })
    },
    
    cadastrarMedicoExame (item) {
      console.log(' em cadastrar medico servico...')
      this.$router.push({
        name: 'cadastrarMedicoExame',
        params: {
          item: item
        }
      })
    },
   
    listarExames (nome) {
      // let exames = null
      this.isLoading = true
      medicoService.medico.listarExamesPorNome(nome, this.sadt == true ? 'LABORATORIO' : 'CLINICA').then(r => {
        if (r.status == 200) {
          console.log(r.data)
          this.count = r.data.length
          this.entries = r.data
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    addExame (item) {
      let isExames = false
      // let exames = []
      this.listaExames.forEach(s => {
        console.log(s.idExame, item.idExame)
        if (s.idExame === item.idExame) isExames = true
      })
      if (!isExames) {
        this.listaExames.push(item)
        for (let i = 0; i < this.listaExames.length; i++) {
          const s = this.listaExames[i]
          s.prescricoes.forEach(e => {
            this.mPrescricoes.push(e)
            // this.sExames.push(e)
          })
        }
      }
      this.$emit('solicitacoes', this.solicitacoesExames)
      // this.exame1 = ''
    },
    cadastrarPacoteExame () {
      if (this.$refs.form.validate()) {
        this.loadCadastro = true
        console.log('em cadastrar Pacote: ', this.listaExames)
        administradorUnidadeService.administradorUnidade.cadastrarPacoteExame('', this.nomePacote, this.listaExames, this.user.idUnidade, this.sadt, true).then(r => {
          console.log('em then cadastrar Pacote')
          if (r.status == 200) {
            this.listarPacoteExames()
            this.cadastroSucesso = true
            this.isAddPacote = false
            setTimeout(() => {
              this.cadastroSucesso = false
            }, 2000)
          }
        }).finally(() => {
          this.loadCadastro = false
          this.listaExames = []
          this.nomePacote = ''
          this.pacoteSelecionado.nome = ''
          this.pacoteSelecionado.exames = []
          this.pacoteSelecionado.medicos = []
        })
      }
    },
    listarPacoteExames () {
      this.loadPacotes = true
      console.log('em listar pacotes')
      administradorUnidadeService.administradorUnidade.listarPacoteExames(this.user.idUnidade, this.sadt).then(r => {
        if (r.status == 200) {
          this.pacotesExames = r.data
        }
      }).finally(() => {
        this.loadPacotes = false
      })
    },
    removerPacoteExame (pacote) {
      administradorUnidadeService.administradorUnidade.cadastrarPacoteExame(pacote._id, pacote.nome, pacote.exames, pacote.idUnidade, pacote.sadt, false).then(r => {
        if (r.status == 200) {
          this.listarPacoteExames()
          this.removerSucesso = true
          setTimeout(() => {
            this.removerSucesso = false
          }, 2000)
        }
      }).finally(() => {
        this.pacoteSelecionado = {}
      })
    },
    exibirEditarPacote (item) {
      // this.searchExame = ''
      this.medicosSelecionados = []
      this.pacoteSelecionado = Object.assign({}, item)
      if (item.exames) {
        this.listaExames = item.exames.slice()
      }
      this.isEditarPacote = true
    },
    exibirVincularMedicos (item) {
      this.medicosSelecionados = []
      this.pacoteSelecionado = Object.assign({}, item)
      if (item.medicos) {
        this.medicosSelecionados = item.medicos
      }
      this.isVincularMedicos = true
    },
    editarPacoteExame () {
      if (this.$refs.form1.validate()) {
        administradorUnidadeService.administradorUnidade.cadastrarPacoteExame(this.pacoteSelecionado, this.pacoteSelecionado.nome, this.listaExames, this.pacoteSelecionado.idUnidade, this.pacoteSelecionado.sadt, true).then(r => {
          if (r.status == 200) {
            this.listarPacoteExames()
            this.editarSucesso = true
            this.isEditarPacote = false
            this.isVincularMedicos = false
          }
        }).finally(() => {
          this.listaExames = []
          setTimeout(() => {
            this.editarSucesso = false
          }, 2000)
        })
      }
    },
    vincularPacote () {
      usuarioService.vincularPacoteExames(this.medicosSelecionados, this.pacoteSelecionado._id).then(r => {
        if (r.status == 200) {
          // console.log('cadastrou pacote medico')
          this.listarPacoteExames()
          this.vincularSucesso = true
          this.isVincularMedicos = false
        }
      }).finally(() => {
        setTimeout(() => {
          this.vincularSucesso = false
        }, 2000)
      })
    },
    listarUsuarios () {
      usuarioService.listarUsuarios().then(r => {
        if (r.status == 200) {
          console.log('USUARIOS: ', r.data)
          this.listaFuncionariosAtivos = r.data
        }
      })
    }
  },
  created () {
    console.log('created...')
  },
  computed: {

    icon () {
      if (this.allSeleced) return 'mdi-close-box'
      if (this.anySelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    exames () {
      return this.entries.map(entry => {
        const Description = entry.nome.length > this.nome
          ? entry.nome.slice(0, this.descriptionLimit) + '...'
          : entry.nome
        return Object.assign({}, entry, {
          Description
        })
      })
    },
    pacotesExamesFiltrados () {
      if (!this.filtroBusca) {
        return this.pacotesExames
      }
      const busca = this.filtroBusca.toLowerCase()
      return this.pacotesExames.filter(item => {
        const nome = item.nome.toLowerCase()
        return nome.includes(busca)
      })
    }
  },
  watch: {
    isVincularMedicos (val) {
      if (val == true) {
        this.listarUsuarios()
      }
    },
    isAddPacote (val) {
      if (val == true) {
        this.listarExames()
      }
    },
    searchExame (val) {
      if (val != null && val != '') {
        this.listarExames(val)
      }
    },
    exameSelecionado (val) {
      if (val != '') {
        this.addExame(val)
      }
    }
  }
}
</script>

    <style scoped>
    .md-card {
      width: 320px;
      margin: 4px;
      display: inline-block;
      vertical-align: top;
    }

    .feedback {
      background-color: #31B0D5;
      color: white;
      padding: 10px 20px;
      border-radius: 4px;
      border-color: #46b8da;
    }

    #mybutton {
      position: fixed;
      bottom: 20px;
      right: 10px;
    }

    .rounded-card {
      border-radius: 35px;
    }
    </style>
